/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUploadBlCodeReqVo
 */
export interface BatchUploadBlCodeReqVo {
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof BatchUploadBlCodeReqVo
     */
    orderIds?: Array<number>;
    /**
     * BL号
     * @type {string}
     * @memberof BatchUploadBlCodeReqVo
     */
    blNo?: string;
    /**
     * 是否在出库计划中 1 是 0 否, 默认 1
     * @type {number}
     * @memberof BatchUploadBlCodeReqVo
     */
    inOutboundPlan?: number;
}

/**
 * Check if a given object implements the BatchUploadBlCodeReqVo interface.
 */
export function instanceOfBatchUploadBlCodeReqVo(value: object): value is BatchUploadBlCodeReqVo {
    return true;
}

export function BatchUploadBlCodeReqVoFromJSON(json: any): BatchUploadBlCodeReqVo {
    return BatchUploadBlCodeReqVoFromJSONTyped(json, false);
}

export function BatchUploadBlCodeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUploadBlCodeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'blNo': json['blNo'] == null ? undefined : json['blNo'],
        'inOutboundPlan': json['inOutboundPlan'] == null ? undefined : json['inOutboundPlan'],
    };
}

export function BatchUploadBlCodeReqVoToJSON(json: any): BatchUploadBlCodeReqVo {
    return BatchUploadBlCodeReqVoToJSONTyped(json, false);
}

export function BatchUploadBlCodeReqVoToJSONTyped(value?: BatchUploadBlCodeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderIds': value['orderIds'],
        'blNo': value['blNo'],
        'inOutboundPlan': value['inOutboundPlan'],
    };
}

